export default "__VITE_ASSET__1243b0dc__"